import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from "rxjs/Observable";

import * as globalConst from './../../../../../constants';
import * as moment from 'moment';
import 'moment/locale/pt-br';

@Injectable()
export class BulkRenewalRequestService {

  private apiUrl = globalConst.baseAPI;  // URL para web api  
  private filters: any = null;
  private selectClients: Set<string> = new Set<string>();
  private selectClientsProperties: Set<any> = new Set<any>();

  constructor(private http: Http) { }

  setFilters(filters) {
    this.filters = filters;
  }

  getFilters() {
    return this.filters;
  }

  cleanFilters() {
    this.filters = null;
  }

  //MÉTODOS PROPRIEDADES DO CLIENTE ID
  setSelectClients(clientID) {
    this.selectClients.add(clientID);
  }

  getSelectClients() {
    return this.selectClients;
  }

  removeSelectClients(clientID) {
    this.selectClients.delete(clientID);
  }

  cleanSelectClients() {
    this.selectClients = new Set<string>();
  }
  //FIM MÉTODOS PROPRIEDADES DO CLIENTE ID

  //MÉTODOS PROPRIEDADES DO CLIENTE SELECIONADO
  setSelectClientsProperties(client) {
    this.selectClientsProperties.add(client);
  }

  getSelectClientsProperties() {
    return this.selectClientsProperties;
  }

  removeSelectClientsProperties(client) {
    this.selectClientsProperties.delete(client);
  }

  cleanSelectClientsProperties() {
    this.selectClientsProperties = new Set<any>();
  }
  //FIM MÉTODOS PROPRIEDADES DO CLIENTE SELECIONADO

  getCTC(baseURL) {
    return this.http
      .get(this.apiUrl + "commercialstructure/v1/" + baseURL + "/C?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getGC(baseURL) {
    return this.http
      .get(this.apiUrl + "commercialstructure/v1/" + baseURL + "/G?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getDirector(baseURL) {
    return this.http
      .get(this.apiUrl + "commercialstructure/v1/" + baseURL + "/D?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getRepresentative(baseURL) {
    return this.http
      .get(this.apiUrl + "representative/v1/" + baseURL + "/?$filter=Ativo eq true&$orderby=Nome asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getAnalyst(token) {
    return this.http
      .get(this.apiUrl + "profilestructure/v1/profile/analyst?&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getConceptBilling(token) {
    return this.http
      .get(this.apiUrl + "billingconcepts/v1/billingconcepts?&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getDelay() {
    return this.http
		.get(this.apiUrl + "/system/v1/getcodparameterstypekey/restricao/diasvcto", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
  }

  getOptionsGuarantees(token){
    return this.http
    .get(this.apiUrl + "typeofguarantee/v1/gettypeofguarantees?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
    .map((res: Response) => res.json()).catch(e => {
      if (e.status === 401) {
        return Observable.throw('Unauthorized');
      }
    });
  }

  getFiltersObject(filter){
    const obj = {
      Codigo: (filter.Codigo == '') ? null : filter.Codigo,
      NomeCliente: (filter.NomeCliente == '') ? null : filter.NomeCliente,
      Apelido: (filter.Apelido == '') ? null : filter.Apelido,
      Documento: (filter.Documento == '') ? null : filter.Documento.replace(/[^a-zA-Z0-9]+/g, ''),
      NomeGrupo: (filter.NomeGrupo == '') ? null : filter.NomeGrupo,
      DeVigenciaLC: (filter.DeVigenciaLC == '' || filter.DeVigenciaLC == null || filter.DeVigenciaLC == undefined) ? null : moment(filter.DeVigenciaLC["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      AteVigenciaLC: (filter.AteVigenciaLC == '' || filter.AteVigenciaLC == null || filter.AteVigenciaLC == undefined) ? null : moment(filter.AteVigenciaLC["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      Rating: (filter.Rating == '') ? null : filter.Rating,
      DeValorLC: (filter.DeValorLC == '') ? null : filter.DeValorLC,
      AteValorLC: (filter.AteValorLC == '') ? null : filter.AteValorLC,
      ClienteTop10Sim: (filter.ClienteTop10Sim == '') ? null : filter.ClienteTop10Sim,
      ClienteTop10Nao: (filter.ClienteTop10Nao == '') ? null : filter.ClienteTop10Nao,
      DeConsultaSerasa: (filter.DeConsultaSerasa == '' || filter.DeConsultaSerasa == null || filter.DeConsultaSerasa == undefined) ? null : moment(filter.DeConsultaSerasa["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      AteConsultaSerasa: (filter.AteConsultaSerasa == '' || filter.AteConsultaSerasa == null || filter.AteConsultaSerasa == undefined) ? null : moment(filter.AteConsultaSerasa["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      RestricaoSerasa: (filter.RestricaoSerasa == '') ? null : filter.RestricaoSerasa,
      RestricoesYaraSim: (filter.RestricoesYaraSim == '') ? null : filter.RestricoesYaraSim,
      RestricoesYaraNao: (filter.RestricoesYaraNao == '') ? null : filter.RestricoesYaraNao,
      RestricaoSerasaGrupoSim: (filter.RestricaoSerasaGrupoSim == '') ? null : filter.RestricaoSerasaGrupoSim,
      RestricaoSerasaGrupoNao: (filter.RestricaoSerasaGrupoNao == '') ? null : filter.RestricaoSerasaGrupoNao,
      RestricoesYaraGrupoSim: (filter.RestricoesYaraGrupoSim == '') ? null : filter.RestricoesYaraGrupoSim,
      RestricoesYaraGrupoNao: (filter.RestricoesYaraGrupoNao == '') ? null : filter.RestricoesYaraGrupoNao,
      LCAndamentoSim: (filter.LCAndamentoSim == '') ? null : filter.LCAndamentoSim,
      LCAndamentoNao: (filter.LCAndamentoNao == '') ? null : filter.LCAndamentoNao,
      AlcadaAndamentoSim: (filter.AlcadaAndamentoSim == '') ? null : filter.AlcadaAndamentoSim,
      AlcadaAndamentoNao: (filter.AlcadaAndamentoNao == '') ? null : filter.AlcadaAndamentoNao,
      DeComCompras: (filter.DeComCompras == '' || filter.DeComCompras == null || filter.DeComCompras == undefined) ? null : moment(filter.DeComCompras["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      AteComCompras: (filter.AteComCompras == '' || filter.AteComCompras == null || filter.AteComCompras == undefined) ? null : moment(filter.AteComCompras["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      DeVigenciaGarantia: (filter.DeVigenciaGarantia == '' || filter.DeVigenciaGarantia == null || filter.DeVigenciaGarantia == undefined) ? null : moment(filter.DeVigenciaGarantia["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      AteVigenciaGarantia: (filter.AteVigenciaGarantia == '' || filter.AteVigenciaGarantia == null || filter.AteVigenciaGarantia == undefined) ? null : moment(filter.AteVigenciaGarantia["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      RepresentanteID: (filter.RepresentanteID == '') ? null : filter.RepresentanteID,
      AnalistaID: (filter.AnalistaID == '') ? null : filter.AnalistaID,
      CTC: (filter.CTC == '') ? null : filter.CTC,
      GC: (filter.GC == '') ? null : filter.GC,
      Diretoria: (filter.Diretoria == '') ? null : filter.Diretoria,
      DePropostaRenovacao: (filter.DePropostaRenovacao == '' || filter.DePropostaRenovacao == null || filter.DePropostaRenovacao == undefined) ? null : moment(filter.DePropostaRenovacao["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      AtePropostaRenovacao: (filter.AtePropostaRenovacao == '' || filter.AtePropostaRenovacao == null || filter.AtePropostaRenovacao == undefined) ? null : moment(filter.AtePropostaRenovacao["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      ClientesRenovadosSim: (filter.ClientesRenovadosSim == '') ? null : filter.ClientesRenovadosSim,
      ClientesRenovadosNao: (filter.ClientesRenovadosNao == '') ? null : filter.ClientesRenovadosNao,
      DeVigenciaLCAdicional: (filter.DeVigenciaLCAdicional == '' || filter.DeVigenciaLCAdicional == null || filter.DeVigenciaLCAdicional == undefined) ? null : moment(filter.DeVigenciaLCAdicional["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      AteVigenciaLCAdicional: (filter.AteVigenciaLCAdicional == '' || filter.AteVigenciaLCAdicional == null || filter.AteVigenciaLCAdicional == undefined) ? null : moment(filter.AteVigenciaLCAdicional["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
      DeValorLCAdicional: (filter.DeValorLCAdicional == '') ? null : filter.DeValorLCAdicional,
      AteValorLCAdicional: (filter.AteValorLCAdicional == '') ? null : filter.AteValorLCAdicional,
      ConceitoCobrancaID: (filter.ConceitoCobrancaID == '') ? null : filter.ConceitoCobrancaID,

      Faturamento: (filter.Faturamento == '') ? null : filter.Faturamento,
      FaturamentoPeriodo: (filter.FaturamentoPeriodo == '') ? null : filter.FaturamentoPeriodo,
      Atraso: (filter.Atraso == '') ? null : filter.Atraso,
      AtrasoPeriodo: (filter.AtrasoPeriodo == '') ? null : filter.AtrasoPeriodo,
      AtrasoDias: (filter.AtrasoDias == '') ? null : filter.AtrasoDias,
      Prorrogacao: (filter.Prorrogacao == '') ? null : filter.Prorrogacao,
      ProrrogacaoPeriodo: (filter.ProrrogacaoPeriodo == '') ? null : filter.ProrrogacaoPeriodo,
      
      TipoGarantia: (filter.TipoGarantia == '') ? null : filter.TipoGarantia,
      StatusGarantia: (filter.StatusGarantia == '') ? null : filter.StatusGarantia
    }

    return obj;
  }

  getBulkRenewal(token, filter, orderby, sort, page, qtd) {
    var obj = this.getFiltersObject(filter);
    const skip = qtd * page;
    return this.http
      .post(this.apiUrl + "renewalLC/v1/client/search?$orderby=" + orderby + " " + sort + "&$top=" + qtd + "&$skip=" + skip, obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getBulkRenewalFiltered(token, orderby, sort, page, qtd) {
    const obj = {
      ContaClienteID: Array.from(this.selectClients)
    };
    const skip = qtd * page;
    return this.http
      .post(this.apiUrl + "renewalLC/v1/client/searchfiltered?$orderby=" + orderby + " " + sort + "&$top=" + qtd + "&$skip=" + skip, obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  exportExcel(token, filter) {
    const obj = this.getFiltersObject(filter);
    const localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
    const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
    return this.http
      .post(this.apiUrl + "renewalLC/v1/client/export", obj, options)
      .map(res => {
        return new Blob([res.blob()], { type: "application/octet-stream" });
      });
  }

  consultaSerasa(clients: Set<string>) {
    const obj = {
      ContaClienteID: Array.from(clients)
    };
    return this.http
      .post(this.apiUrl + "serasa/v1/searchList", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  criarProposta(dataNovaVigencia: string, dataNovaVigenciaAdicional: string, valorNovoLC: number, valorNovoLCAdicional: number, clients: Set<string>) {
    const formatDate = (date: string) => date === '' ? null : moment(date["jsdate"]).format("YYYY-MM-DD HH:mm:ss");

    const obj = {
      DataNovaVigencia: formatDate(dataNovaVigencia),
      ContaClienteID: Array.from(clients),
      DataNovaVigenciaAdicional: formatDate(dataNovaVigenciaAdicional),
      ValorNovoLC: valorNovoLC,
      ValorNovoLCAdicional: valorNovoLCAdicional
    };

    return this.http
      .post(this.apiUrl + "renewalLC/v1/proposal/insert", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/bulk-renewal/component/bulk-renewal-request/service/bulk-renewal-request.service.ts